import { Flex, Text, Box, Image as ImageComponent } from '@chakra-ui/react'
import Head from 'next/head'
import router from 'next/router'
import React, { useState } from 'react'
import { AboutCard } from '../../components/AboutUs/aboutCard'
import { BreadCrumb } from '../../components/AppHeader/BreadCrumb'
import { AuthModal } from '../../components/Auth/withAuthModal'
import { RatingBanner, UploadListingBanner, PerformanceBanner } from '../../components/Banner'
import { PrimaryButton } from '../../components/button'
import { TrustedCompanies } from '../../components/Landing'
import { realtorsFAQ, publicListings, publicListingTools } from '../../data'
import { WrapperStyle } from '../../styles/newDesignStyles'
import { HeaderText, RealtorsHeader, RealtorsSemiHeader, SemiHeaderText } from '../../styles/typography'
import { useAuth } from '../../utils/auth/newAuth'

const Realtors = () => {

    const [isAuthBoxOpen, setisAuthBoxOpen] = useState(false);
    const { user } = useAuth();

    return (
        <>
            <Head>
                <title key="title">Realtors - Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="Buy, list and prospect buyers for your public and private business and commercial real estate listings all on Zonado. Sign up and get started for free." />
                <meta key="og:title" property="og:title" content='Realtors - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="Buy, list and prospect buyers for your public and private commercial real estate listings all on Zonado. Sign up and get started for free." />

                <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
                <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
                <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
                <link key="fav5" rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
                <link key="fav6" rel="shortcut icon" href="/favicons/favicon.ico" />
                <link rel="canonical" href="https://zonado.com/who-we-help/realtors" />
                <meta key="msFav" name="msapplication-TileColor" content="#2d89ef" />
                <meta name="msapplication-config" content="favicons/browserconfig.xml" />
                <meta name="theme-color" content="#ffffff" />

            </Head>

            <AuthModal
                createListing
                onClose={() => setisAuthBoxOpen(false)}
                isOpen={isAuthBoxOpen}
                
            />

            <WrapperStyle>

                {/* breadcrumb */}
                <BreadCrumb to={"Realtors"} />

                <Flex flexDir={{ base: "column", md: "row" }} mt={{ md: "0", lg: "50px" }} justifyContent={"space-between"} alignItems={"center"}>
                    <Flex
                        // px={{ md: "0", lg: "50px" }}
                        pt={{ base: "68px", md: "33px", lg: "26px" }}
                        pb={{ base: "0", lg: "26px" }}
                        flexDir={"column"} w={{ md: "40%", lg: "49%" }}
                    >
                        <HeaderText text={"Power your workflow "} />

                        <SemiHeaderText
                            text={"Zonado was built to escape the frustrations shared by Canadian Commercial Real Estate Agents. Broken transacting process and fragmented flow is history with Zonado. "}
                        />

                        <PrimaryButton
                            mb={"36px"} label={"List for sale or lease"}
                            mr={"auto"} mt={"43px"}
                            onClick={() => user ? router.push("/add-listing") : setisAuthBoxOpen(true)}
                        />

                    </Flex>

                    <Box w={{ md: "50%" }} py={"14px"} pr={"11px"}>
                        <ImageComponent src={"/images/newLanding/realtorBanner.svg"} h={"100%"} objectFit={"contain"} w={["100%", "350px", "100%"]} mx={"auto"} />
                    </Box>
                </Flex>

                <Flex flexDir={"column"} mt={"50px"} >
                    <Text color={"gray.500"} fontSize={"16px"}>Trusted by</Text>

                    <Flex flexDir={"row"} mt={"23px"} className={"trustedCompanies"}>
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image_2.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 4.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/Vector.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 30.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 7.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 3.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 6.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 22.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 5.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 8.svg"} />
                    </Flex>
                </Flex>

                <Box mt={"96px"}>
                    <RealtorsHeader
                        text={"Sale of Business and Commercial Real Estate from across Canada"}
                    />
                    <RealtorsSemiHeader text={"Zonado connects buyers, private investors with Realtors & Business Brokers across the nation. Buy, Sell, Lease and Prospect Buyers all on one platform."}
                    />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            publicListings.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* performance banner */}
                <PerformanceBanner />

                {/* broker tools  */}
                <Box>
                    <RealtorsHeader text={"A powerful suite of broker tools"} />
                    <RealtorsSemiHeader text={"Zonado was built as a result of intensive user interviews with Commercial Real Estate agents from across Canada. The result is a suite of elegant solutions to power your workflow"} />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            publicListingTools.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* upload listing banner */}
                <UploadListingBanner
                    bannerBody={<>Send us listing details/flyer with photos and we will put up your listing in less than 24 hours, <strong>free</strong>.</>}
                    bannerHeader={"Let us upload your listing for you"}
                    bannerImage={"/images/newLanding/realtorsListingBanner.png"}
                    btnText={"Send listing details"}
                />

                {/* ratings banner */}
                <RatingBanner
                    ratingImg={"/images/newLanding/getStartedSection.png"}
                    ratingHeader={"An Investor's perspective"}
                    review={"I always felt that there wasn’t a platform that was easy to use with legitimate listings for Commercial Real Estate in Canada. We have started using Zonado to discover listings that we would never see on MLS."}
                    reviewer={"- Harsimrat Singh"}
                />

            </WrapperStyle>
        </>
    )
}

export default Realtors

Realtors.isProfessional = true;
Realtors.faq = realtorsFAQ;